import { Injectable, ErrorHandler, InjectionToken, Inject } from '@angular/core';
import * as Rollbar from 'rollbar';
import { environment } from '../../environments/environment';

const rollbarConfig: Rollbar.Configuration = {
  accessToken: environment.rollbarToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment.production ? 'production' : 'development',
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) {}

  handleError(err: any): void {
    this.rollbar.error(err.originalError || err);
    console.error(err);
  }
}
